// extracted by mini-css-extract-plugin
export default {"mask":"index_mask_QGl9G","box":"index_box_190sG","close":"index_close_oismu","page":"index_page_xVBKK"};